import TomSelect from 'tom-select';
import { $, $$ } from '../helpers/shortcuts';

function initializeMultiSelect() {
  if ($$('.tomselect-custom').length === 0) return;

  const tomSelect = new TomSelect('.tomselect-custom', {
    plugins: ['no_active_items', 'restore_on_backspace'],
    render: {
      no_results: () =>
        `<div class="no-results">Keine Ergebnisse gefunden</div>`,
    },
  });

  // simulate reset button behaviour
  $$('[data-multiselect-reset]').forEach(($resetButton) => {
    $resetButton.addEventListener('click', (e) => {
      e.preventDefault && e.preventDefault();
      tomSelect.clear();
    });
  });
}

export { initializeMultiSelect };
